import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconJump: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconJump"><Path d="M7.75 19.25L16.25 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M15 4.75H21.25V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M20.5 5.5C16 9.5 12.5 13.5 12 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Path d="M11.9998 19.0002V18.9125C11.9998 12.8287 6.98889 7.50594 1.75 7.03418" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconJump;
